import lax from 'lax.js';

window.lax = lax;

window.addEventListener('load', () => {
  lax.init();

  lax.addDriver('scrollY', () => {
    return window.scrollY;
  }, {
    inertiaEnabled: true,
  });

  // lax.addElements('.lax-image_shift img, .lax-image_shift iframe', {
  //   scrollY: {
  //     translateY: [
  //       ['elInY', 'elOutY'],
  //       [-200, 0]
  //     ]
  //   }
  // });
});
